/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-12-05 12:32:20
 * Modified By: Val Liu
 * -----
 */

import { lang } from "@root/core/i18n";
import { StringHelper } from "../../utilities";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "../core";

// @uiEraseSerial - forcely remove the `[0-9a-z]+.` from the beginning.

@UITag.set()
export class uiEraseSerial extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableBodyCell, EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true;

    /// set props from rule object
    parse(input: IUITagInput): IUITagResult | null {
        /// default to true
        let rule = this.parseRule(input) ?? true;

        const value = input.inputs.props?.value;
        if (rule == false || typeof value !== "string") return null;

        return {
            props: {
                value: lang.translate(StringHelper.eraseSerial(value)),
            },
        };
    }
}
